import SeoSettings from "./Forms/SeoSettings";
import CrawlPostModal from "./Modals/CrawlPostModal";
import DoFollowListModal from "./Modals/DoFollowListModal";
import RobotsModal from "./Modals/RobotsModal";
import Header from "./Header";
import SeoWidget from "./SeoWidget";

export const components = {
  SeoSettings,
  CrawlPostModal,
  DoFollowListModal,
  RobotsModal,
  Header,
  SeoWidget,
};
